function collectApiErrorMessages(value) {
  if (typeof value === 'string') {
    const normalizedValue = value.trim();
    return normalizedValue ? [normalizedValue] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(item => collectApiErrorMessages(item));
  }

  if (!value || typeof value !== 'object') {
    return [];
  }

  const prioritizedMessages = [
    value.message,
    value.error,
    value.detail,
    value.details,
    value.errors,
    value.messages,
  ].flatMap(item => collectApiErrorMessages(item));

  if (prioritizedMessages.length > 0) {
    return prioritizedMessages;
  }

  return Object.values(value).flatMap(item => collectApiErrorMessages(item));
}

export function getApiErrorMessage(error, fallback = 'Request failed.') {
  const responseData = error?.response?.data;

  const errorMessages = [...new Set(collectApiErrorMessages(responseData))];

  if (errorMessages.length > 0) {
    return errorMessages.join(' | ');
  }

  if (responseData && typeof responseData === 'object') {
    try {
      return JSON.stringify(responseData);
    } catch (serializationError) {
      // Ignore JSON serialization failures and fall back to the default message.
    }
  }

  return fallback;
}

export function isPlainUnauthorized(error) {
  const responseData = error?.response?.data;

  if (error?.response?.status !== 401) {
    return false;
  }

  if (typeof responseData === 'string') {
    return responseData.trim().toLowerCase() === 'unauthorized';
  }

  return responseData?.message === 'Unauthorized';
}
